module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Temperature-full-184677152eba7af120658c501060391c.svg";